<template>
	<div>
		<div class="uk-width-1-1@s uk-width-1-1@m">
				<ul class="uk-nav uk-nav-default uk-margin-top" uk-sticky>
						<li class="uk-nav-header">Наши магазины</li>
						<li><a href="#" @click.prevent="toShop">ул. Евдокимова</a></li>
						<li class="uk-nav-divider"></li>
						<li><a href="#" @click.prevent="toShop">пр. Ворошиловский</a></li>
						<li class="uk-nav-divider"></li>
						<li><a href="#" @click.prevent="toShop">ул. Горького</a></li>
				</ul>
		</div>
	</div>
</template>

<script>
export default {
	data () {
	return {}
	},
	methods: {
		toShop () {
			this.$router.push('/shops')
		}
	}
}
</script>